import { Injectable } from '@angular/core';
import { SettingsService } from './settings.service';
import { CloseReason } from '../models/close-reason.model';
import { LoggingService } from './logging.service';
import { LOG_EVENTS } from '../models/log-event.model';
import { OptionsService } from './options.service';

@Injectable()
export class InvitationService {

    private _hasInvitation: boolean;

    constructor(
        private settingsService: SettingsService,
        private loggingService: LoggingService,
        private optionsService: OptionsService
    ) {
        this.optionsService.options$.subscribe(o => {
            this._hasInvitation = !!o.Invitation;
        });
    }

    acceptInvitation(): void {
        parent.postMessage('uwfAcceptInvitation', '*');
        console.log('Chat invitation has been accepted.');
        this.loggingService.logEvent(LOG_EVENTS.InvitationAccept);
    }

    hideInvitation(reason: CloseReason): void {
        parent.postMessage('uwfHideInvitation', '*');
        console.log(`Chat invitation has been hidden. Reason: ${CloseReason[reason]}`);
        switch (reason) {
            case CloseReason.Auto:
                this.loggingService.logEvent(LOG_EVENTS.InvitationTimeOut);
                break;
            case CloseReason.ByUser:
                this.loggingService.logEvent(LOG_EVENTS.InvitationDecline);
                break;
        }
    }

    showInvitation(): void {
        if (!this._hasInvitation) {
            console.log('Invitation settings is not available.  Accepting invitation by default');
            this.acceptInvitation();
            return;
        }

        parent.postMessage('uwfShowInvitation', '*');
        console.log('Chat invitation has been shown.');
        this.loggingService.logEvent(LOG_EVENTS.InvitationOffer);
        this.settingsService.lastInvitationTimestamp = Date.now();
    }

    showProactivErrorView(): void {
        parent.postMessage('uwfShowInvitation', '*');
        console.log('Proactive Chat error view has been shown.');
    }
}
